var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.3104 16.7552C39.9309 15.2771 38.8127 14.1129 37.3929 13.7179C34.8194 13 24.5 13 24.5 13C24.5 13 14.1807 13 11.6071 13.7179C10.1873 14.113 9.06909 15.2771 8.68957 16.7552C8 19.4344 8 25.0243 8 25.0243C8 25.0243 8 30.6141 8.68957 33.2933C9.06909 34.7714 10.1873 35.8871 11.6071 36.2821C14.1807 37 24.5 37 24.5 37C24.5 37 34.8193 37 37.3929 36.2821C38.8127 35.8871 39.9309 34.7714 40.3104 33.2933C41 30.6141 41 25.0243 41 25.0243C41 25.0243 41 19.4344 40.3104 16.7552ZM21.125 30.0994V19.9491L29.7499 25.0244L21.125 30.0994Z","fill":"currentColor"}));
}

YoutubeInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
